module.exports = __webpack_public_path__ + "static/media/close-icon.26e3f45a.svg";